import React from "react";

export default function Why() {
  const html = `<div class="container">
<div class="row row-cols-1 row-cols-sm-2 row-cols-md-1 g-1">
<div class="container-md">
<span class="style1"><b>Why Choose Shri Ghanamatheshwar College of Education (B.Ed.)?</b></span>
<div class="card shadow-sm">
<div class="justified-text">
<ol>
<li><b>Comprehensive Curriculum:</b> Our curriculum is designed to provide a strong theoretical foundation along with practical teaching skills. With a focus on contemporary educational methods, we prepare students for modern classroom environments.</li>
<li><b>Experienced Faculty:</b> Our faculty members are highly qualified, with years of experience in the field of education. They are dedicated to mentoring students, providing academic guidance, and encouraging professional growth.</li>
<li><b>Modern Facilities:</b> The college offers state-of-the-art facilities, including smart classrooms, a well-equipped library with digital access, subject-specific laboratories, and recreational areas to ensure a holistic learning experience.</li>
<li><b>Hands-on Experience:</b> We believe in learning by doing. Our program includes regular teaching practice sessions, internships, and opportunities for students to gain real classroom experience in a variety of educational settings.</li>
<li><b>Personalized Attention:</b> With smaller class sizes, we ensure that each student receives individualized attention and support from faculty members, enhancing the learning experience.</li>
<li><b>Placement Support:</b> Our dedicated placement cell assists students in securing teaching positions in reputed schools, providing guidance on resume building, interview skills, and career planning.</li>
<li><b>Research and Innovation:</b> We encourage our students to engage in educational research, helping them develop a critical understanding of the field and contribute to educational innovation.</li>
<li><b>Focus on Values and Ethics:</b> We instill in our students the importance of professional ethics, social responsibility, and empathy—qualities essential for successful educators.</li>
</ol>
</div>
</div>
</div>
</div>
</div>`;
  return (
    <div className="container my-4">
      <div dangerouslySetInnerHTML={{ __html: html }} />
    </div>
  );
}
